// Level5.js
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import arrow_down from "../../assets/keyboard_arrow_down.svg";
// import { useRef } from "react";
import {
  updateLevel5,
  updateLevel6,
  updateLevel7,
} from "../../store/QuestionnaireSlice";
import { useRef } from "react";
import editPen from "../../assets/edit_pen.svg";
import trash from "../../assets/trash.svg";
import { forwardRef, useImperativeHandle } from "react";

const Level5 = forwardRef(
  ({ onNext, onBack, placement, editError, setEditError }, ref) => {
    const dispatch = useDispatch();
    // const selectorData = useSelector((state) => state.questionnaire.level5Data);
    // const [valueStreams, setValueStreams] = useState(selectorData);
    const valueStreams =
      useSelector((state) => state.questionnaire.level5Data) || [];

    const level7Data =
      useSelector((state) => state.questionnaire.level7Data) || [];

    // useEffect(() => {
    //   setValueStreams(selectorData);
    // }, [selectorData]);
    // useEffect(() => {
    //   console.log("value-stream -> ", valueStreams);
    // }, valueStreams);
    const level1Data =
      useSelector((state) => state.questionnaire.level1Data) || [];
    const questions = useSelector((state) => state.questionnaire.questions);

    const [activeDropdown, setActiveDropdown] = useState(null);
    const [showProductDropdown, setShowProductDropdown] = useState(null);
    const [editIndex, setEditIndex] = useState(null); // Tracks the index of the stream being edited
    const [editValue, setEditValue] = useState(""); // Tracks the current input value for editing
    // const [isButtonClick, setIsButtonClick] = useState(false);
    const [error, setError] = useState("");
    useImperativeHandle(ref, () => ({
      handleNextClick,
    }));

    const handleAddValueStream = () => {
      const streamNumber = valueStreams.length + 1;
      const newStream = {
        _id: "",
        name: `Value-Stream ${streamNumber}`,
        product: "",
      };
      dispatch(updateLevel5([...valueStreams, newStream]));
    };

    const handleSelectProduct = (streamIndex, product) => {
      const updatedStreams = valueStreams.map((stream, index) => {
        if (index === streamIndex) {
          return { ...stream, product };
        }
        return stream;
      });
      dispatch(updateLevel5(updatedStreams));
      setShowProductDropdown(null);
    };

    const handleSaveStream = (index) => {
      if (editValue.trim()) {
        const updatedStreams = [...valueStreams];
        console.log({ valueStreams });
        console.log(editValue);
        updatedStreams.splice(index, 1, {
          ...valueStreams[index],
          name: editValue,
        });

        let updatedLevel7Data = { ...level7Data };
        updatedLevel7Data = {
          ...updatedLevel7Data,
          [editValue]: updatedLevel7Data[valueStreams[index].name],
        };
        if (editValue !== valueStreams[index].name) {
          delete updatedLevel7Data[valueStreams[index].name];
        }
        dispatch(updateLevel5(updatedStreams));
        dispatch(updateLevel7(updatedLevel7Data));
        setEditIndex(null);
        setEditValue("");
      } else {
        setError("Stream title cannot be empty");
        setEditIndex(null);
        return "Stream title cannot be empty";
      }
    };

    const handleEditStream = (index, currentName) => {
      setEditIndex(index);
      setEditValue(currentName);
      setActiveDropdown(null);
    };

    const handleDeleteStream = (index) => {
      const updatedStreams = valueStreams.filter((_, i) => i !== index);
      dispatch(updateLevel5(updatedStreams));
      setActiveDropdown(null);
    };

    const handleNextClick = () => {
      if (valueStreams.length === 0) {
        setError("Please add at least one value stream");
        return "Please add atleast one value stream";
      }
      const incompleteStream = valueStreams.find((stream) => !stream.product);
      if (incompleteStream) {
        setError("Please select a product for all value streams");
        return "Please select a product for all value streams";
      }
      setError("");
      if (onNext) {
        onNext();
      }
    };

    const dropdownRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setActiveDropdown(null);
          setShowProductDropdown(null);
        }
        // if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        //   if (!isButtonClick) {
        //     setActiveDropdown(null);
        //     setShowProductDropdown(null);
        //   }
        //   setIsButtonClick(false); // Reset button click state
        // }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    return (
      <div>
        <div
          className={` pb-6 px-10 mx-auto rounded-lg max-w-[1200px] ${
            placement !== "edit" ? "bg-[#F4F5F6] pt-[30px]" : "bg-white"
          }`}
        >
          <div className="bg-[#1C3F3A] text-white px-[10px] py-[7px] w-fit rounded-md text-xs">
            Level {questions[4]?.level || "5"}
          </div>
          <p
            className={`mt-3 mb-6 font-medium ${
              placement === "edit" ? "text-[1.125rem]" : "text-[1.25rem]"
            }`}
          >
            {questions[4]?.description}
          </p>
          {(error || editError) && (
            <p className="flex justify-between items-center bg-red-100 border-l-2 border-0 mb-5 border-red-400 text-red-700 px-4 py-3">
              {error ? error : editError}
              <span
                className="cursor-pointer"
                onClick={() => {
                  if (editError) {
                    setEditError("");
                  } else {
                    setError("");
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 26 26"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </span>
            </p>
          )}
          <div className="space-y-4">
            {valueStreams.map((stream, index) => (
              <div key={index} className="flex items-center gap-4">
                {editIndex === index ? (
                  <div className="max-w-[210px]">
                    <input
                      type="text"
                      value={editValue}
                      onChange={(e) => setEditValue(e.target.value)}
                      onBlur={() => handleSaveStream(index)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          handleSaveStream(index);
                        }
                      }}
                      className="border border-gray-300 rounded-lg w-full px-[0.75rem] py-[0.325rem] text-[16px] outline-none"
                      autoFocus
                    />
                  </div>
                ) : (
                  <div
                    className="relative flex items-center justify-between px-[0.75rem] py-[0.325rem] min-w-[210px] bg-white rounded-lg shadow-sm border border-[#D9D9D9] "
                    onClick={() => handleEditStream(index, stream.name)}
                  >
                    <span className="text-[16px] font-medium">
                      {stream.name}
                    </span>
                    <button
                      className="ml-2 text-gray-400 p-1"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteStream(index);
                        // setIsButtonClick(true);
                        // setActiveDropdown(
                        //   activeDropdown === index ? null : index
                        // );
                      }}
                    >
                      <img src={trash} alt="" className="" />
                    </button>
                    {/* {activeDropdown === index && (
                      <div
                        ref={dropdownRef}
                        className="absolute right-0 top-6 w-32 bg-white rounded-md shadow-lg border border-gray-200 z-50"
                      >
                        <button
                          className="w-full px-4 py-2 text-left text-sm border-b border-[#D9D9D9] hover:bg-gray-100 flex items-center gap-2"
                          onClick={() => handleEditStream(index, stream.name)}
                        >
                          <img src={editPen} alt="" className="" />
                          {editIndex === null ? "Edit" : "Save"}
                        </button>
                        <button
                          className="w-full px-4 py-2 text-left text-sm hover:bg-gray-100 flex items-center gap-2"
                          onClick={() => handleDeleteStream(index)}
                        >
                          <img src={trash} alt="" className="" />
                          Delete
                        </button>
                      </div>
                    )} */}
                  </div>
                )}

                <div className="relative">
                  <button
                    onClick={() =>
                      setShowProductDropdown(
                        showProductDropdown === index ? null : index
                      )
                    }
                    className="px-4 py-1 w-[200px] text-left border border-gray-300 rounded-md text-[#1C3F3A] bg-white opacity-50"
                  >
                    {stream.product || "Select Product"}
                    <img
                      src={arrow_down}
                      alt=""
                      className="absolute right-3 top-1/2 transform -translate-y-1/2"
                    />
                  </button>
                  {showProductDropdown === index && (
                    <div
                      ref={dropdownRef}
                      className="absolute mt-1 w-[200px] bg-white rounded-md shadow-lg border border-gray-200 z-20 max-h-48 overflow-y-auto"
                    >
                      {level1Data.map((product, pIndex) => (
                        <button
                          key={pIndex}
                          className="w-full px-4 py-2 text-left hover:bg-gray-100"
                          onClick={() =>
                            handleSelectProduct(index, product.name)
                          }
                        >
                          {product.name}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}

            <button
              onClick={handleAddValueStream}
              className="relative py-[0.375rem] w-[210px] font-medium rounded-[6px] text-[#1C3F3A] hover:bg-[#f0f0f0] transition-colors"
            >
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 210 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="absolute inset-0"
                preserveAspectRatio="none"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="99%"
                  height="97%"
                  rx="5.5"
                  fill="white"
                  stroke="#1C3F3A"
                  strokeWidth="1"
                  strokeDasharray="4 4"
                />
              </svg>
              <span className="relative z-10">Add New Value-Stream</span>
            </button>
          </div>
        </div>
        {placement !== "edit" && (
          <div className="flex justify-between mt-[26px]">
            <button
              className="border text-[#1C3F3A] border-[#D9D9D9] flex gap-3 justify-center items-center py-[0.825rem] rounded-[10px] font-inter font-medium px-5 hover:bg-[#f0f0f0] transition-colors"
              onClick={onBack}
            >
              <svg
                width="17"
                height="8"
                viewBox="0 0 17 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.80775 0.192239L4.52125 0.899989L1.92125 3.49999H17V4.49999H1.92125L4.5155 7.09999L3.802 7.80774L0 3.99999L3.80775 0.192239Z"
                  fill="#1C3F3A"
                />
              </svg>
              Back
            </button>
            <button
              className="bg-[#55C880] flex items-center justify-center gap-3 text-white pl-5 pr-6 py-[0.825rem] rounded-[10px] overflow-hidden"
              onClick={handleNextClick}
            >
              Next
              <svg
                width="17"
                height="8"
                viewBox="0 0 17 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.1923 7.80776L12.4788 7.10001L15.0788 4.50001H0V3.50001H15.0788L12.4845 0.900011L13.198 0.192261L17 4.00001L13.1923 7.80776Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        )}
      </div>
    );
  }
);

export default Level5;
